import React, { useState } from 'react';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import type { CardMetric } from '@ctd/agent-contract';
import { formatMetricValue } from '../utils/card-format';
import { DeltaChip } from './delta-chip';
import style from '../style.module.scss';

/** The metrics of the KPI the question did not ask for: folded away, totals and changes only. */
export const OtherMetrics: React.FC<{ metrics: CardMetric[] }> = ({
    metrics,
}) => {
    const [open, setOpen] = useState(false);

    if (metrics.length === 0) {
        return null;
    }

    return (
        <div className={style.others}>
            <button
                type="button"
                className={style.others_toggle}
                aria-expanded={open}
                onClick={() => setOpen(!open)}
            >
                {open
                    ? 'Hide'
                    : `${metrics.length} more metric${
                          metrics.length === 1 ? '' : 's'
                      }`}
                {open ? (
                    <UpOutlined aria-hidden="true" />
                ) : (
                    <DownOutlined aria-hidden="true" />
                )}
            </button>
            {open && (
                <dl className={style.others_list}>
                    {metrics.map((metric) => (
                        <div key={metric.id} className={style.other}>
                            <dt>{metric.label}</dt>
                            <dd>
                                <span>{formatMetricValue(metric)}</span>
                                {metric.compare && (
                                    <DeltaChip
                                        metric={metric}
                                        compare={metric.compare}
                                    />
                                )}
                            </dd>
                        </div>
                    ))}
                </dl>
            )}
        </div>
    );
};
